import { render, staticRenderFns } from "./TestLogin.vue?vue&type=template&id=2afcee46&"
import script from "./TestLogin.vue?vue&type=script&lang=js&"
export * from "./TestLogin.vue?vue&type=script&lang=js&"
import style0 from "./TestLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports